import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "outer-entwicklungsplan" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Entwicklungsplan", -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.notiz == '')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "- Es wurde noch kein Entwicklungsplan hinterlegt -"))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, [
      _createElementVNode("pre", null, _toDisplayString(_ctx.notiz), 1)
    ])
  ]))
}